import { MenuItem, TextField } from "@material-ui/core";
import { useState } from "react";
import AddRemoveButtons from "../../../../../components/buttons/AddRemoveButtons";

const CategoryInput = ({
  erroCategory,
  isAddSubCategoryLoading,
  handleProductChange,
  handleAddSubCategory,
  product,
  subCategories,
}) => {
  const [newSubCategoryValue, setNewSubCategoryValue] = useState("");
  const handleAdd = () => {
    handleAddSubCategory(newSubCategoryValue);
  };
  return (
    <>
      <div className="d-flex mb-4 ">
        <TextField
          onChange={(event) => handleProductChange(event)}
          value={product?.productCategory}
          name="productCategory"
          variant="outlined"
          error={erroCategory}
          required
          select
          label="Categoria"
          className="col-lg-12 fz-16 text-cl-dark-jungle-green ff-univanova"
        >
          {subCategories.map((category) => (
            <MenuItem key={category._id} value={category._id}>
              {category.name}
            </MenuItem>
          ))}
        </TextField>
        {/* <div className="d-flex">
          {isAddSubCategoryLoading ? (
            <div className="spinner-border spinner-border-sm text-light" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          ) : (
            <>
              <TextField
                onChange={(event) => setNewSubCategoryValue(event.target.value)}
                value={newSubCategoryValue}
                name="newCategory"
                label={"Nova categoria"}
                variant={"outlined"}
                className=" col-lg-auto fz-16 text-cl-dark-jungle-green ff-univanova ms-3"
              />
              <AddRemoveButtons
                className="ms-3"
                style={{ marginTop: "-4px" }}
                isRemoveButtonActive={false}
                handleAdd={handleAdd}
              />
            </>
          )}
        </div> */}
      </div>
    </>
  );
};

export default CategoryInput;
